var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.31,
    height: 60,
    viewBox: "0 0 39.31 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_lock_4222614_000000",
    d: "M25.485,29.516V19.171A14.482,14.482,0,0,1,39.968,4.688v0A14.482,14.482,0,0,1,54.45,19.171V29.516h4.138a1.034,1.034,0,0,1,1.034,1.034v33.1a1.034,1.034,0,0,1-1.034,1.034H21.347a1.034,1.034,0,0,1-1.034-1.034V30.55a1.034,1.034,0,0,1,1.034-1.034ZM37.9,49.334a6.207,6.207,0,1,1,4.138,0V55.9a2.069,2.069,0,0,1-4.138,0Zm9.31-19.818v-9.31a7.242,7.242,0,0,0-14.483,0v9.31Z",
    transform: "translate(-20.313 -4.688)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cad2084e4b3eeee8f909702fabba89cc.svg";
export { ForwardRef as ReactComponent };